import React, { useState } from 'react';
import { Container, Row, Col, Form, Modal } from 'react-bootstrap';
import { FaCheckCircle } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import emailjs from '@emailjs/browser';
import config from '../../config';
import './Careers.scss';

// EmailJS'i başlat
emailjs.init("VmrwNxG-4MiE4mR5M");

const CareersPage = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    full_name: '',  // backend ile uyumlu olması için field isimlerini değiştirdik
    email: '',
    phone: '',
    position: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const [showSuccess, setShowSuccess] = useState(false); // Modal için state

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Backend'e kaydet
      const response = await axios.post(`${config.API_URL}/careers`, formData);
      
      if (response.data.success) {
        // Email sadece backend başarılı olduğunda gönderilsin
        const emailResult = await emailjs.send(
          'service_qw9qmql',
          'template_0l2k1wp',
          {
            from_name: formData.full_name,
            from_email: formData.email,
            phone: formData.phone,
            position: formData.position,
            message: formData.message,
          },
          'VmrwNxG-4MiE4mR5M'
        );
      
        if (emailResult.status === 200) {
          setShowSuccess(true);
          setFormData({
            full_name: '',
            email: '',
            phone: '',
            position: '',
            message: ''
          });
        }
      }
    } catch (error) {
      console.error('Error:', error);
      alert(t('careers.error'));
    }
  };

  return (
    <section id="careers" className="careers-section">
      <Container>
        <Row className="align-items-center">
          <Col md={6}>
            <div className="careers-content" data-aos="fade-right">
              <h2>{t('careers.title')}</h2>
              <p>
                {t('careers.description')}
              </p>
            </div>
          </Col>
          <Col md={6}>
            <div className="careers-form" data-aos="fade-left" data-aos-delay="200">
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>{t('careers.form.full_name')}</Form.Label>
                      <Form.Control 
                        type="text" 
                        name="full_name"
                        value={formData.full_name}
                        onChange={handleChange}
                        placeholder={t('careers.form.full_name_placeholder')} 
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>{t('careers.form.email')}</Form.Label>
                      <Form.Control 
                        type="email" 
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder={t('careers.form.email_placeholder')} 
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>{t('careers.form.phone')}</Form.Label>
                      <Form.Control 
                        type="tel" 
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        placeholder={t('careers.form.phone_placeholder')} 
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>{t('careers.form.position')}</Form.Label>
                      <Form.Control 
                        type="text" 
                        name="position"
                        value={formData.position}
                        onChange={handleChange}
                        placeholder={t('careers.form.position_placeholder')} 
                      />
                    </Form.Group>
                  </Col>
                  <Col md={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>{t('careers.form.message')}</Form.Label>
                      <Form.Control 
                        as="textarea" 
                        rows={3} 
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        placeholder={t('careers.form.message_placeholder')} 
                      />
                    </Form.Group>
                  </Col>
                  <Col md={12} className="d-flex justify-content-end">
                    <button 
                      type="submit" 
                      className="btn btn-primary"
                    >
                      {t('careers.form.submit')}
                    </button>
                  </Col>
                </Row>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
      
      {/* Success Modal */}
      <Modal 
        show={showSuccess} 
        onHide={() => setShowSuccess(false)}
        centered
      >
        <Modal.Body className="text-center p-4">
          <FaCheckCircle size={50} color="#28a745" className="mb-3" />
          <h4>{t('careers.success.title')}</h4>
          <p>{t('careers.success.message')}</p>
          <button 
            className="btn btn-success mt-3" 
            onClick={() => setShowSuccess(false)}
          >
            {t('careers.success.close')}
          </button>
        </Modal.Body>
      </Modal>
    </section>
  );
};

export default CareersPage;